export const TRACKING_CONFIG = {
  googleAnalytics: {
    id: 'UA-258047499-1',
    gtmId: 'GTM-TRLWF5P',
  },
  hotjar: {
    id: 5361042,
    version: 6,
  },
  tiktok: {
    pixelId: 'CVO0OHJC77U26M0ILOQ0',
  },
  facebook: {
    pixelId: '382956617896760',
  },
} as const 
